import { AbstractFormValue } from "src/models/form-value/abstract-form-value";

export class FormValue<T> extends AbstractFormValue<T> {}
